var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"profile-item"},[_c('i',{class:_vm.icon}),(_vm.name)?_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.name)+" :")]):_vm._e(),_c('div',{staticClass:"text",class:{ bold: _vm.name }},[_vm._v(" "+_vm._s(_vm.text)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }